import { DesignSystem } from "../design-system";
import { Table } from "./table";
import { styles } from "./table.styles";
import { template } from "./table.template";
export const definition = Table.compose({
    name: `${DesignSystem.prefix}-table`,
    template: template,
    styles: styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=table.definition.js.map